module.exports = __webpack_public_path__ + "img/3.1e2a1f2f.png";